import { envConfig } from 'utility';
import { getQueryString } from 'utility/helpers';
import { globalEndpoints } from './global';

export const securityEndpoints = {
  authenticate: '/Security/Authenticate',
  authenticateSso: '/Security/AuthenticateSso',
  logout: `${envConfig.apiUrl}/Security/Logout`,
  getCurrentUser: '/Security/CurrentUser',
  updateUser: '/Security/EditProfile',
  checkLoginId: '/Security/IsLoginIdAvailable',
  checkEmailAddress: '/Security/IsEmailAvailable',
  updateProfile: '/Security/EditProfile',
  changePassword: '/Security/ChangePassword',
  scopedRoles: '/Security/ScopedRoles',
  signatureValidation: '/Security/SelfSignature',
  keepAlive: () => {
    return `${globalEndpoints.apiUrl}/Security/KeepAlive`;
  },
  dismissTrainingNotification: '/Security/DismissTrainingNotification',
  forgotPassword: '/Security/ForgotPassword',
  resetPassword: '/Security/ResetPassword',
  registrationCheck: (options) => {
    const queryString = getQueryString(options);
    return `${globalEndpoints.apiUrl}/Security/RegistrationCheck?${queryString}`;
  },
  register: (options) => {
    const queryString = getQueryString(options);
    return `${globalEndpoints.apiUrl}/Security/Register?${queryString}`;
  },
  checkMaintenanceMode: () => {
    return `${globalEndpoints.apiUrl}/Security/CheckMaintenanceMode`;
  },
  environmentServers: () => {
    return `${globalEndpoints.apiUrl}/Security/EnvironmentServers`;
  },
  VerifyTOTP: () => {
    return `${globalEndpoints.apiUrl}/Security/VerifyTotp`;
  },
  generateEmailMfa: () => {
    return `${globalEndpoints.apiUrl}/Security/GenerateEmailMfa`;
  },
  verifyEmailMfa: () => {
    return `${globalEndpoints.apiUrl}/Security/VerifyEmailMfa`;
  },
  resetMfa: () => {
    return `${globalEndpoints.apiUrl}/Security/ResetMfa`;
  }
};
